import Vue from 'vue';
import BootstrapVue, { IconsPlugin } from 'bootstrap-vue';
import '../assets/scss/theme.scss';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
